module.exports = __webpack_public_path__ + "a06785ee45feb76c91d1006f052781d7.svg";